<template>
  <TsMedia :data-testid="dataTestid + '-card'" :append-class="twMerge('mb-4', appendClass)">
    <TsMediaStart append-class="mr-0 relative text-white">
      <svg xmlns="http://www.w3.org/2000/svg" width="17" height="58" viewBox="0 0 17 58" fill="none">
        <path
          d="M17 0V58H3.87436C1.72608 58 0 56.6396 0 54.9683V38.0027C1.32871 38.0027 2.42148 37.1476 2.42148 36.0982C2.42148 35.0488 1.32871 34.2034 0 34.2034V33.2608C1.32871 33.2608 2.42148 32.4155 2.42148 31.3661C2.42148 30.3166 1.32871 29.4713 0 29.4713V28.5287C1.32871 28.5287 2.42148 27.6834 2.42148 26.6339C2.42148 25.7206 1.6019 24.9626 0.509131 24.778C0.347699 24.7489 0.17385 24.7294 0 24.7294V23.7966C1.32871 23.7966 2.42148 22.9415 2.42148 21.8921C2.42148 21.6783 2.3718 21.4743 2.28488 21.2799C2.07378 20.7941 1.62673 20.3957 1.0431 20.1819C0.720234 20.0653 0.372535 19.9973 0 19.9973V3.03166C0 1.36036 1.72608 0 3.87436 0H17Z"
          fill="#238826" />
      </svg>
      <TsTypography
        append-class="text-sideways absolute rotate-180 top-[20%] left-[20%] text-[8px] tracking-widest uppercase">{{
          useTranslation("discount" , "Korting")
        }}</TsTypography>
    </TsMediaStart>
    <TsMediaContent append-class="bg-success/15 rounded-r-sm p-2">
      <TsTypography append-class="mb-0 text-success text-sm" weight="semibold" :data-testid="dataTestid">{{ message }}
      </TsTypography>
    </TsMediaContent>
  </TsMedia>
</template>

<script lang="ts" setup>
import { useTranslation } from "~/composables/useTranslation";
import { twMerge, type ClassNameValue } from "tailwind-merge";

const TsMediaContent = defineAsyncComponent(
  () => import('~/components/organisms/TsMediaContent.vue')
);

const TsMediaStart = defineAsyncComponent(
  () => import('~/components/organisms/TsMediaStart.vue')
);

type Props = {
  message?: string;
  appendClass?: ClassNameValue;
  dataTestid: string;
};

const props = withDefaults(defineProps<Props>(), {
  message: "default promo message",
});
</script>
